import { capitalize, startCase, toLower } from 'lodash-es';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class IssMissingTranslationHandler implements MissingTranslationHandler {
  public handle({ key }: MissingTranslationHandlerParams): string {
    const paths: string[] = key.split('.');
    return capitalize(startCase(toLower(paths[paths.length - 1]))) || '-';
  }
}
